import { render } from "./ClientLogos.vue?vue&type=template&id=4c73962b"
import script from "./ClientLogos.vue?vue&type=script&lang=js"
export * from "./ClientLogos.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__